// Mock data for American Flag Company

export const products = {
  usFlags: [
    // Nylon Flags
    {
      id: 'us-nylon-1',
      name: 'American Flag - 2x3 ft Endura-Nylon',
      category: 'US Flags',
      price: 39.50,
      description: 'Aniline-dyed 100% heavyweight 200-denier nylon bunting. Fast drying, fade resistant, flies in the slightest breeze.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Endura-Nylon Material', 'Fade Resistant', 'White Poly-Cotton Header', 'Made in USA'],
      material: 'Nylon',
      inStock: true,
      bestseller: false
    },
    {
      id: 'us-nylon-2',
      name: 'American Flag - 3x5 ft Endura-Nylon',
      category: 'US Flags',
      price: 49.95,
      description: 'Premium quality nylon with embroidered stars and sewn stripes. Fast drying and fade resistant.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['200-Denier Nylon', 'Embroidered Stars', 'Sewn Stripes', 'Made in USA'],
      material: 'Nylon',
      inStock: true,
      bestseller: true
    },
    {
      id: 'us-nylon-3',
      name: 'American Flag - 4x6 ft Endura-Nylon',
      category: 'US Flags',
      price: 59.95,
      description: 'Heavyweight nylon flag perfect for residential display. Flies beautifully in light winds.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Heavyweight Nylon', 'Fast Drying', 'Treated to Resist Fading', 'Made in USA'],
      material: 'Nylon',
      inStock: true,
      bestseller: true
    },
    {
      id: 'us-nylon-4',
      name: 'American Flag - 5x8 ft Endura-Nylon',
      category: 'US Flags',
      price: 125.00,
      description: 'Large format nylon flag for commercial and residential flagpoles.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['200-Denier Nylon', 'Commercial Grade', 'Fade Resistant', 'Made in USA'],
      material: 'Nylon',
      inStock: true,
      bestseller: false
    },
    {
      id: 'us-nylon-5',
      name: 'American Flag - 6x10 ft Endura-Nylon',
      category: 'US Flags',
      price: 162.00,
      description: 'Extra large nylon flag perfect for tall flagpoles and commercial properties.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Extra Large', 'Heavyweight Material', 'Professional Grade', 'Made in USA'],
      material: 'Nylon',
      inStock: true,
      bestseller: false
    },
    {
      id: 'us-nylon-6',
      name: 'American Flag - 8x12 ft Endura-Nylon',
      category: 'US Flags',
      price: 295.00,
      description: 'Premium oversized flag for large commercial flagpoles.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Oversized', 'Commercial Grade', 'Endura-Nylon', 'Made in USA'],
      material: 'Nylon',
      inStock: true,
      bestseller: false
    },
    {
      id: 'us-nylon-7',
      name: 'American Flag - 10x15 ft Endura-Nylon',
      category: 'US Flags',
      price: 402.00,
      description: 'Largest nylon flag available. Perfect for corporate campuses and large facilities.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Largest Size', 'Premium Quality', 'Professional Installation Recommended', 'Made in USA'],
      material: 'Nylon',
      inStock: true,
      bestseller: false
    },
    // Polyester Flags
    {
      id: 'us-poly-1',
      name: 'American Flag - 3x5 ft Poly-Max',
      category: 'US Flags',
      price: 64.69,
      description: '2-ply 100% polyester bunting. Open weave reduces wind resistance, ideal for high wind areas.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['2-Ply Polyester', 'Open Weave', 'High Wind Resistant', 'Made in USA'],
      material: 'Polyester',
      inStock: true,
      bestseller: true
    },
    {
      id: 'us-poly-2',
      name: 'American Flag - 4x6 ft Poly-Max',
      category: 'US Flags',
      price: 84.60,
      description: 'Extremely durable polyester flag perfect for commercial applications.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Poly-Max Material', 'Extremely Durable', 'Commercial Grade', 'Made in USA'],
      material: 'Polyester',
      inStock: true,
      bestseller: true
    },
    {
      id: 'us-poly-3',
      name: 'American Flag - 5x8 ft Poly-Max',
      category: 'US Flags',
      price: 259.90,
      description: 'Heavy-duty polyester flag designed for extended flag life in harsh conditions.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['2-Ply Construction', 'Wind Resistant', 'Long Lasting', 'Made in USA'],
      material: 'Polyester',
      inStock: true,
      bestseller: false
    },
    {
      id: 'us-poly-4',
      name: 'American Flag - 6x10 ft Poly-Max',
      category: 'US Flags',
      price: 320.00,
      description: 'Large format polyester flag for commercial and industrial applications.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Commercial Grade', 'Open Weave', 'High Durability', 'Made in USA'],
      material: 'Polyester',
      inStock: true,
      bestseller: false
    },
    {
      id: 'us-poly-5',
      name: 'American Flag - 8x12 ft Poly-Max',
      category: 'US Flags',
      price: 475.00,
      description: 'Oversized polyester flag built for the toughest weather conditions.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Oversized', 'Weather Resistant', 'Industrial Grade', 'Made in USA'],
      material: 'Polyester',
      inStock: true,
      bestseller: false
    }
  ],
  stateFlags: [
    {
      id: 'state-1',
      name: 'Alabama State Flag - 3x5 ft',
      category: 'State Flags',
      price: 29.99,
      description: 'Official Alabama state flag made with premium materials.',
      image: 'https://images.unsplash.com/photo-1509315811345-672d83ef2fbc?w=800',
      features: ['Official Design', 'Fade Resistant', 'Brass Grommets', 'Made in USA'],
      inStock: true,
      bestseller: true
    },
    {
      id: 'state-2',
      name: 'Georgia State Flag - 3x5 ft',
      category: 'State Flags',
      price: 29.99,
      description: 'High-quality Georgia state flag for indoor or outdoor use.',
      image: 'https://images.unsplash.com/photo-1444464666168-49d633b86797?w=800',
      features: ['Vibrant Colors', 'Weather Resistant', 'Sewn Design', 'Made in USA'],
      inStock: true,
      bestseller: false
    }
  ],
  military: [
    {
      id: 'mil-1',
      name: 'US Marine Corps Flag - 3x5 ft',
      category: 'Military',
      price: 39.99,
      description: 'Show your support for the US Marine Corps with this premium flag.',
      image: 'https://images.unsplash.com/photo-1509118159797-a9e0e8e0e58e?w=800',
      features: ['Official Colors', 'Double Sided', 'Durable Fabric', 'Made in USA'],
      inStock: true,
      bestseller: true
    },
    {
      id: 'mil-2',
      name: 'US Army Flag - 3x5 ft',
      category: 'Military',
      price: 39.99,
      description: 'Honor the US Army with this high-quality military flag.',
      image: 'https://images.unsplash.com/photo-1521677043137-cd2f58a5e53e?w=800',
      features: ['Official Design', 'Heavy Duty', 'Brass Grommets', 'Made in USA'],
      inStock: true,
      bestseller: true
    }
  ],
  poles: [
    {
      id: 'pole-arch-20',
      name: 'Architectural Elite Series - 20 ft Flagpole',
      category: 'Poles',
      price: 1099.99,
      description: 'Heavy-duty aluminum flagpole with gold anodized ball and premium hardware. Meets stringent architectural standards.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Gold Anodized Aluminum Ball', 'Cast Aluminum Truck Assembly', 'Complete External Halyard', 'Galvanized Ground Sleeve'],
      specs: [
        'Gold Anodized Aluminum Ball',
        'Cast Aluminum Single Revolving Truck Assembly with Aluminum Pulley',
        'Complete External Halyard Assembly',
        'Rope Halyard - #10 Polypropylene',
        'Two Heavy-Duty Stainless Steel Swivel Snap Hooks',
        'Two Neoprene Snap Hook Covers',
        '9" Heavy-Duty Aluminum Cleat',
        'Spun Aluminum Flash Collar',
        'Galvanized 16-Gauge Corrugated Steel Ground Sleeve with Steel Grounding Spike'
      ],
      inStock: true,
      bestseller: true,
      series: 'Architectural Elite'
    },
    {
      id: 'pole-arch-25',
      name: 'Architectural Elite Series - 25 ft Flagpole',
      category: 'Poles',
      price: 1299.99,
      description: 'Premium commercial-grade aluminum flagpole perfect for business properties.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Architectural Standards', 'Premium Hardware', 'External Halyard', 'Professional Grade'],
      specs: [
        'Gold Anodized Aluminum Ball',
        'Cast Aluminum Single Revolving Truck Assembly',
        'Complete External Halyard Assembly',
        'Heavy-Duty Stainless Steel Hardware',
        '9" Aluminum Cleat',
        'Galvanized Steel Ground Sleeve'
      ],
      inStock: true,
      bestseller: true,
      series: 'Architectural Elite'
    },
    {
      id: 'pole-arch-30',
      name: 'Architectural Elite Series - 30 ft Flagpole',
      category: 'Poles',
      price: 1499.99,
      description: 'Professional flagpole for commercial and industrial properties. Enhanced landscape aesthetics.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['30 ft Height', 'Commercial Grade', 'Gold Anodized Ball', 'Premium Quality'],
      specs: [
        'Meets Stringent Architectural Standards',
        'Gold Anodized Aluminum Ball',
        'Premium Hardware Package',
        'External Halyard System',
        'Professional Installation Recommended'
      ],
      inStock: true,
      bestseller: false,
      series: 'Architectural Elite'
    },
    {
      id: 'pole-arch-40',
      name: 'Architectural Elite Series - 40 ft Flagpole',
      category: 'Poles',
      price: 1999.99,
      description: 'Large commercial flagpole with highest quality hardware. Perfect for corporate campuses.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['40 ft Height', 'Corporate Grade', 'Complete Hardware', 'Lifetime Warranty'],
      specs: [
        'Heavy-Duty Aluminum Construction',
        'Cast Aluminum Revolving Truck',
        'Stainless Steel Hardware Throughout',
        'Galvanized Ground Sleeve',
        'Professional Installation Required'
      ],
      inStock: true,
      bestseller: false,
      series: 'Architectural Elite'
    },
    {
      id: 'pole-res-20',
      name: 'Residential Aluminum Flagpole - 20 ft',
      category: 'Poles',
      price: 799.99,
      description: 'Complete residential flagpole kit with all hardware included.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Aluminum Construction', 'Includes Hardware', 'Easy Install', 'Lifetime Warranty'],
      inStock: true,
      bestseller: true,
      series: 'Residential'
    },
    {
      id: 'pole-fiber-25',
      name: 'Commercial Fiberglass Flagpole - 25 ft',
      category: 'Poles',
      price: 1199.99,
      description: 'Heavy-duty fiberglass flagpole for businesses and high-wind areas.',
      image: 'https://customer-assets.emergentagent.com/job_patriot-flags/artifacts/1atth5y5_image.png',
      features: ['Fiberglass', 'Weather Resistant', 'Professional Grade', '25 Year Warranty'],
      inStock: true,
      bestseller: false,
      series: 'Commercial'
    }
  ]
};

export const testimonials = [
  {
    id: 1,
    name: 'Michael Thompson',
    location: 'Destin, FL',
    rating: 5,
    text: 'Outstanding service! The team helped me choose the perfect flagpole for my beachfront home and the installation was flawless. Highly recommend!',
    date: '2024-01-15'
  },
  {
    id: 2,
    name: 'Sarah Martinez',
    location: 'Santa Rosa Beach, FL',
    rating: 5,
    text: 'Been buying from Coastal Flag Company for years. Quality products, fair prices, and they truly care about their coastal customers.',
    date: '2024-02-20'
  },
  {
    id: 3,
    name: 'James Davis',
    location: 'Sandestin, FL',
    rating: 5,
    text: 'The custom flag they created for our resort exceeded expectations. Fast turnaround and beautiful craftsmanship! Perfect for the coast.',
    date: '2024-03-10'
  }
];

export const pastProjects = [
  {
    id: 1,
    title: 'Beachfront Resort Flagpole Installation',
    location: 'Destin, FL',
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800',
    description: '35ft hurricane-resistant flagpole with lighting system for luxury resort'
  },
  {
    id: 2,
    title: 'Marina & Yacht Club Project',
    location: 'Sandestin, FL',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=800',
    description: 'Multiple marine-grade flagpoles with nautical and state flags'
  },
  {
    id: 3,
    title: 'Coastal Estate Installation',
    location: '30A, FL',
    image: 'https://images.unsplash.com/photo-1505228395891-9a51e7e86bf6?w=800',
    description: 'Custom 30ft beachfront flagpole with solar lighting and hurricane protection'
  },
  {
    id: 4,
    title: 'Gulf Coast Commercial Complex',
    location: 'Panama City Beach, FL',
    image: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800',
    description: 'Corporate offices outfitted with coastal-grade flagpoles and custom company flags'
  }
];

export const categories = [
  { name: 'U.S. Flags', slug: 'us-flags', icon: 'Flag' },
  { name: 'State Flags', slug: 'state-flags', icon: 'MapPin' },
  { name: 'Military & Civil Service', slug: 'military', icon: 'Shield' },
  { name: 'Fan Gear', slug: 'fan-gear', icon: 'Heart' },
  { name: 'Custom & More', slug: 'custom', icon: 'Sparkles' },
  { name: 'Poles & Hardware', slug: 'poles', icon: 'Wrench' },
  { name: 'Accessories', slug: 'accessories', icon: 'Package' }
];

// Shopping cart functionality
let cart = [];

export const addToCart = (product) => {
  const existingItem = cart.find(item => item.id === product.id);
  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    cart.push({ ...product, quantity: 1 });
  }
  localStorage.setItem('cart', JSON.stringify(cart));
  return cart;
};

export const removeFromCart = (productId) => {
  cart = cart.filter(item => item.id !== productId);
  localStorage.setItem('cart', JSON.stringify(cart));
  return cart;
};

export const updateCartQuantity = (productId, quantity) => {
  const item = cart.find(item => item.id === productId);
  if (item) {
    item.quantity = quantity;
    if (item.quantity <= 0) {
      cart = cart.filter(item => item.id !== productId);
    }
  }
  localStorage.setItem('cart', JSON.stringify(cart));
  return cart;
};

export const getCart = () => {
  const stored = localStorage.getItem('cart');
  if (stored) {
    cart = JSON.parse(stored);
  }
  return cart;
};

export const clearCart = () => {
  cart = [];
  localStorage.removeItem('cart');
  return cart;
};

export const getCartTotal = () => {
  return cart.reduce((total, item) => total + (item.price * item.quantity), 0);
};